import { useSystemStatus } from './use-system-status';
import type { IExerciseMode } from './system-status';

/**
 * #812 — is this deployment a REHEARSAL, and what does the mark say?
 *
 * Rides on the BFF `/health` read the sidebar footer already polls (one public GET per
 * minute, cached by react-query), so the banner and the printed coupons need no second
 * request and no build-time flag: a drill box flips `NEXA_EXERCISE_MODE` on its BFF and
 * every open console picks it up within the minute.
 *
 * `null` while the read is pending or failed — callers treat that exactly like "off",
 * never like "on": an unreachable BFF must not stamp a real coupon as an exercise.
 */
export function useExerciseMode(): IExerciseMode | null {
  const { data } = useSystemStatus();
  const exercise = data?.exercise;
  if (!exercise?.enabled) return null;
  const label = exercise.label?.trim();
  return label ? { enabled: true, label } : null;
}
